// extracted by mini-css-extract-plugin
export const title = "OfferHighlights-module--title--3SjyP";
export const header = "OfferHighlights-module--header--2i_QG";
export const offers = "OfferHighlights-module--offers--1Zv1j";
export const variantLarge = "OfferHighlights-module--variant-large--2qXtp";
export const variantSmall = "OfferHighlights-module--variant-small--IFTX9";